import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Link, useNavigate } from "react-router-dom";
import { usePrivy, useLogin } from "@privy-io/react-auth";

const CustomDialogEmpty = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { authenticated } = usePrivy();
  const navigate = useNavigate();

  const { login } = useLogin({
    onComplete: async ({ wasAlreadyAuthenticated }) => {
      if (!wasAlreadyAuthenticated) {
        navigate("/agents");
      }
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-64 md:max-w-2xl">
        <DialogTitle
          className="text-center text-primary text-2xl"
          data-testid="creator-opening-message"
        >
          Welcome to Memetica!
        </DialogTitle>
        <div className="p-1 md:p-4 mb-1 md:mb-4 text-center text-sm md:text-base">
          <p>
            The next-gen world of AI agent where your ideas come to life! Build
            your first AI Agent and unlock epic tools to grow, vibe, and make
            your digital presence totally yours. Whether you’re creating
            content, leveling up your influence, or diving into something new,
            Memetica is your gateway to making it happen.
          </p>
        </div>
        <DialogFooter>
          {authenticated ? (
            <Button className="w-full" asChild>
              <Link to="/agents/new">Create New Agent</Link>
            </Button>
          ) : (
            <div className="flex flex-col gap-2 w-full">
              <Button
                data-testid="modal-launch-button"
                className="w-full"
                onClick={() => {
                  login();
                  onClose();
                }}
              >
                Launch
              </Button>
              <Button className="w-full" onClick={onClose}>
                Explore our agents
              </Button>
            </div>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CustomDialogEmpty;
